
import { Component, Vue } from 'vue-property-decorator';
import SendMessageCard from '@/components/messages/SendMessageCard.vue';
import MessageTemplateListCard from '@/components/messages/MessageTemplateListCard.vue';
import { PLATFORMS_METADATA } from '@/constants';
import { SupportedPlatform } from 'ignite360-core';

@Component({
  name: 'project-content-messages',
  components: { SendMessageCard, MessageTemplateListCard },
})
export default class ProjectContentMessages extends Vue {
  get whatsAppLogo(): string {
    return (
      PLATFORMS_METADATA.find((platform) => platform.value === SupportedPlatform.WhatsApp)?.image ||
      ''
    );
  }

  async loadSentMessages() {
    // TODO: Similar to posts
  }
}
